module.exports = __webpack_public_path__ + "assets/img/51@3x.0ce3bab1.png";